import * as React from 'react';
import { useAccountCashflowsCpsHisPaieDate } from '../../hooks';
import { ActorApiDateDisplay } from '../../../../../../components/display/date';

export const AccountsCashflowsCpsHisPaieDate = () => {
  const {
    data,
    isLoading,
    error,
  } = useAccountCashflowsCpsHisPaieDate();
  return (
    <ActorApiDateDisplay
      data={data}
      isLoading={isLoading}
      error={error}
    />
  );
};
